import { ReactComponent as ArowLeft } from "../../Assets/images/arrow-left.svg";
import { ReactComponent as ChatCircleDots } from "../../Assets/images/ChatCircleDots.svg";

function ElementHeader({ onBackClick, onHistoryClick, periodicTableWidth, isMobileView, hideHistoryButton }) {
  const showHistory = !hideHistoryButton && !isMobileView && ((periodicTableWidth ?? 100) === 100);
  return (
    <div className="header-component-hero-container-element">
      <div
        className="element-header-menu-icon-container"
        onClick={onBackClick}
      >
        <ArowLeft />
      </div>
      <div className="element-header-title">
        Periodic Table of the Self<span className="trademark">™</span>
      </div>
      {showHistory ? (
        <div
          className="elements-options-button"
          onClick={onHistoryClick}
        >
          <ChatCircleDots />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default ElementHeader;
